import React, { useEffect, useRef, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function VatEnquiryPrices({ job, services, onApplied }) {
  const [lines,setLines] = useState(() => services.map(service => ({ id:'service:'+service.id, unit_price:'', entry_basis:'', treatment:'' })))
  const [evidence,setEvidence] = useState('')
  const [review,setReview] = useState(null)
  const [busy,setBusy] = useState(false)
  const [error,setError] = useState('')
  const request = useRef(null)
  const mounted = useRef(true)
  useEffect(()=>{mounted.current=true;return()=>{mounted.current=false}},[])
  const edit = (index,key,value) => {
    setLines(current => current.map((line,i) => i === index ? {...line,[key]:value} : line))
    setReview(null); request.current=null
  }
  async function run(apply) {
    setBusy(true);setError('')
    try {
      if (apply) {
        if (!review) throw new Error('Review prices first.')
        const fingerprint=JSON.stringify({review,evidence})
        if (request.current?.fingerprint!==fingerprint) request.current={fingerprint,key:crypto.randomUUID()}
        const {data,error:err}=await supabase.rpc('apply_workshop_vat_enquiry_prices',{p_job_id:job.id,p_idempotency_key:request.current.key,p_expected_prices:review,p_evidence:evidence.trim()})
        if (err) throw new Error(err.message)
        if (mounted.current) await onApplied(data)
      } else {
        const {data,error:err}=await supabase.rpc('workshop_vat_enquiry_prices',{p_job_id:job.id,p_lines:lines})
        if (err) throw new Error(err.message)
        if (mounted.current) setReview(data)
      }
    } catch(err) {if(mounted.current){setReview(null);setError(err.message)}} finally {if(mounted.current)setBusy(false)}
  }
  return <fieldset disabled={busy}>
    <legend>Review assessment prices</legend>
    <p>This job started as an enquiry. Enter the assessed service prices and tax treatment. Customer agreement is recorded separately.</p>
    {error && <div className="alert alert-error" role="alert">{error}</div>}
    {lines.map((line,i)=><div className="sec" key={line.id}>
      <strong>{services[i].name}</strong>
      <div className="grid-2">
        <div className="field"><label>Entered price<input aria-label={`${services[i].name} entered price`} type="number" min="0" step="0.01" value={line.unit_price} onChange={e=>edit(i,'unit_price',e.target.value)} /></label></div>
        <div className="field"><label>Price basis<select aria-label={`${services[i].name} price basis`} value={line.entry_basis} onChange={e=>edit(i,'entry_basis',e.target.value)}><option value="">Choose basis</option><option value="inclusive">Includes VAT</option><option value="exclusive">Excludes VAT</option></select></label></div>
        <div className="field"><label>Tax treatment<select aria-label={`${services[i].name} tax treatment`} value={line.treatment} onChange={e=>edit(i,'treatment',e.target.value)}><option value="">Choose treatment</option><option value="standard">Standard rate</option><option value="reduced">Reduced rate</option><option value="zero">Zero rated</option><option value="exempt">Exempt</option><option value="outside_scope">Outside scope</option><option value="not_registered">Not VAT registered</option></select></label></div>
      </div>
    </div>)}
    <div className="field"><label>Assessment pricing evidence<textarea value={evidence} maxLength={1000} onChange={e=>{setEvidence(e.target.value);request.current=null}} /></label></div>
    <button className="btn btn-secondary btn-sm" type="button" disabled={busy || lines.some(l=>!l.unit_price || !l.entry_basis || !l.treatment)} onClick={()=>run(false)}>Review customer total</button>
    {review && <section aria-label="Reviewed assessment totals" role="status" style={{padding:12,margin:'12px 0',border:'1px solid var(--border)',borderRadius:8}}>
      <div className="detail-row"><span>Subtotal (excluding VAT)</span><strong>£{(review.tax.net_minor/100).toFixed(2)}</strong></div>
      <div className="detail-row"><span>{review.configuration?.registration==='not_registered'?'VAT not charged — not VAT registered':'VAT'}</span><strong>£{(review.tax.tax_minor/100).toFixed(2)}</strong></div>
      <div className="detail-row"><span>Total</span><strong>£{(review.tax.gross_minor/100).toFixed(2)}</strong></div>
      <button className="btn btn-primary btn-sm" type="button" disabled={busy || evidence.trim().length<5} onClick={()=>run(true)}>Save reviewed prices for quote</button>
    </section>}
  </fieldset>
}
